import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import PimsterStickyStoryWidget from './pimster-sticky-story-widget';
import { getPlacementStyle } from '../pimster-sticky-widget/pimster-sticky-widget.utils';
import { closeButton } from '../components/close-button';
import { getStoryPreviewHeightStyle } from '../pimster-story-preview/pimster-story-preview.utils';

type RenderParams = {
  placement: PimsterStickyStoryWidget['placement'];
  display: PimsterStickyStoryWidget['display'];
  embedSrc: PimsterStickyStoryWidget['embedSrc'];
  iframeId: PimsterStickyStoryWidget['iframeId'];
  isVisible: PimsterStickyStoryWidget['isVisible'];
  computedHeight: PimsterStickyStoryWidget['computedHeight'];
  withTitle: PimsterStickyStoryWidget['withTitle'];
  close: PimsterStickyStoryWidget['close'];
};

export const renderContent = ({
  placement,
  display,
  embedSrc,
  iframeId,
  isVisible,
  computedHeight,
  withTitle,
  close,
}: RenderParams) => html`
  <div
    class="sticky-story-wrapper ${display} ${isVisible
      ? ''
      : 'hidden'} ${withTitle ? 'with-title' : ''}"
    style=${styleMap({
      ...getPlacementStyle(placement),
      ...getStoryPreviewHeightStyle(display, computedHeight),
    })}
  >
    ${closeButton({ className: display, isHidden: !isVisible, onClick: close })}
    <iframe
      id="${iframeId}"
      class="iframe ${display}"
      allow="autoplay; clipboard-read; clipboard-write"
      title="${iframeId}"
      src="${embedSrc}"
    ></iframe>
  </div>
`;
